import {Service, ChosenService, ChosenServiceDescription} from "./type";

export const service: Array<Service> = [
    {
        id: 1,
        title: 'Мероприятия для специалистов вузов, ОИВов, муниципалитетов и пр.',
        services:[
            {
                id: 101,
                title: 'Проведение обучающего семинара для кураторов академических групп',
                price: '15 000 ₽',
                description: {
                    id: 1001,
                    description: 'Тема согласовывается с заказчиком',
                    price_departure: '20 000 ₽',
                    price_city: '15 000 ₽',
                    time: '1,5 часа (2 ак. ч.)'
                }
            },
            {
                id: 102,
                title: 'Проведение обучающего семинара для ППС и кураторов по маркерам деструктивного поведения среди обучающихся',
                price: '25 000 ₽',
                description: {
                    id: 1002,
                    description: 'Лекционное занятие + практика',
                    price_departure: '50 000 ₽',
                    price_city: '25 000 ₽',
                    time: '3,5 часа (6 ак. ч.)'
                }
            },
            {
                id: 103,
                title: 'Участие в мероприятии в качестве эксперта (Открытый диалог, круглый стол, панельная дискуссия и пр.)',
                price: '15 000 ₽',
                description: {
                    id: 1003,
                    description: 'Работа на площадке организатора',
                    price_departure: '20 000 ₽',
                    price_city: '15 000 ₽',
                    time: '1,5 часа (2 ак. ч.)'
                }
            },
            {
                id: 104,
                title: 'Проведение вебинара с ответами на вопросы участников',
                price: '10 000 ₽',
                description: {
                    id: 1004,
                    description: 'Тематика согласовывается с заказчиком. Тематика находится в сфере проблематики профилактики негативных явлений в молодёжной среде',
                    price_departure: '10 000 ₽',
                    price_city: '10 000 ₽',
                    time: 'от 1 до 3 ак. ч. (40 минут — 2 часа)'
                }
            },
            {
                id: 105,
                title: 'Проведение очных курсов повышения квалификации по программам НЦПТИ',
                price: '80 000 ₽',
                description: {
                    id: 1005,
                    description: 'Тема согласовывается с заказчиком. Возможность выдачи удостоверений о повышении квалификации',
                    price_departure: '100 000 ₽',
                    price_city: '80 000 ₽',
                    price_postscript: `
до 20 чел.
4000 ₽ каждый следующий
                        `,
                    time: '1 программа — 8 ак. ч.'
                }
            },
            {
                id: 106,
                title: 'Проведение очных курсов повышения квалификации по программам НЦПТИ',
                price: '140 000 ₽',
                description: {
                    id: 1006,
                    description: 'Тема согласовывается с заказчиком. Возможность выдачи удостоверений о повышении квалификации',
                    price_departure: '180 000 ₽',
                    price_city: '140 000 ₽',
                    price_postscript: `до 20 чел.
7000 ₽ каждый следующий`,
                    time: '2 программа — 16 ак. ч.'
                }}
        ]
    },
    {
        id: 2,
        title: 'Мероприятия для студентов, школьников, молодёжи',
        services: [
            {
                id: 201,
                title: 'Проведение профилактического мероприятия «под ключ»',
                price: '15 000 ₽',
                description: {
                    id: 2001,
                    description: 'Проведение профилактического мероприятия (любого из «Сборника сценариев»)',
                    price_departure: '20 000 ₽',
                    price_city: '15 000 ₽',
                    time: '1,5 часа (2 ак. ч.)'
                }
            },
            {
                id: 202,
                title: 'Разработка и проведение профилактического мероприятия под запрос заказчика',
                price: 'Договорная стоимость',
                description: {
                    id: 2002,
                    description: 'Разработка профилактического мероприятия под ТЗ заказчика',
                    price_departure: 'Договорная стоимость',
                    price_city: 'Договорная стоимость',
                    time: 'от 1 до 4 ак. ч. (по согласованию)'
                }
            },
            {
                id: 203,
                title: 'Подготовка материалов для проведения кураторского часа',
                price: '10 000 ₽',
                description: {
                    id: 2003,
                    description: 'Тема согласовывается. Предоставляется текст сценария и необходимый сопроводительный материал (презентация/видеоматериал/раздаточный материал)',
                    price_departure: '10 000 ₽',
                    price_city: '10 000 ₽',
                    time: '1 ак. ч.'
                }
            },
            {
                id: 204,
                title: 'Разработка и реализация профилактического проекта',
                price: 'Договорная стоимость',
                description: {
                    id: 2004,
                    description: 'Озвучивание заказчиком проблемного вопроса (с точки зрения профилактики) и совместное формирование ТЗ',
                    price_departure: 'Договорная стоимость',
                    price_city: 'Договорная стоимость',
                    time: 'от 4 до 40 часов (по согласованию), но не более 5 дней.'
                }
            },
            {
                id: 205,
                title: 'Диагностика системы профилактики вуза и последующая консультация руководства вуза',
                price: '120 000 ₽',
                description: {
                    id: 2005,
                    description: `Результат:
- аналитическая записка о состоянии системы профилактики в вузе;
- рекомендации по улучшению системы профилактики в вузе;
- проведение рабочего семинара со специалистами с разъяснением результатов диагностики системы профилактики.
`,
                    price_departure: '150 000 ₽',
                    price_city: '120 000 ₽',
                    time: '5 рабочих дней.'
                }
            },
            {
                id: 206,
                title: 'Консультация вуза по решению проблемной ситуации (адресная/индивидуальная профилактика) с выездом в вуз',
                price: '70 000 ₽',
                description: {
                    id: 2006,
                    description: 'Анализ ситуации, подготовка рекомендаций для специалистов вуза. При необходимости — подключение внешних субъектов профилактики.',
                    price_departure: '90 000 ₽',
                    price_city: '70 000 ₽',
                    time: '3 дня'
                }
            },
        ]
    },
    {
        id: 3,
        title: 'Услуги в сфере медиа',
        services:[
            {
                id: 301,
                title: 'Проведение фестиваля/медиашколы социальной рекламы «Параллели» «под ключ»',
                price: '400 000 ₽',
                description: {
                    id: 3001,
                    description: 'Учим молодёжь создавать социальную рекламу',
                    price_departure: '500 000 ₽',
                    price_city: '400 000 ₽',
                    time: 'от 2 до 7 дней (от 3 человек)'
                }
            },
            {
                id: 302,
                title: 'Создание публикаций для социальных сетей и сайтов «под ключ»',
                price: '8 000 ₽',
                description: {
                    id: 3002,
                    description: 'Подготовка публикаций для вашего сообщества в социальной сети, сайта, лендинга',
                    price_departure: '8 000 ₽',
                    price_city: '8 000 ₽',
                    time: '1 публикация.'
                }
            },
            {
                id: 303,
                title: 'Проведение обучающего семинара для специалистов в сфере медиа',
                price: '20 000 ₽',
                description: {
                    id: 3003,
                    description: 'Семинар по вопросам создания и ведения сообществ в социальных медиа и СМИ по запросу. Настройка работы медиа: сайты, соцсети и т. д.',
                    price_departure: 'от 20000 до 60000 ₽',
                    price_city: 'от 10000 до 40000 ₽',
                    time: 'от 2 до 6 ак. ч.'
                }
            },
            {
                id: 304,
                title: 'Разработка наружней социальной рекламы «под ключ»',
                price: '50 000 ₽',
                description: {
                    id: 3004,
                    description: 'Создание плакатов и баннеров для размещения на городских площадках',
                    price_departure: '50 000 ₽',
                    price_city: '50 000 ₽',
                    time: 'Комплект макетов'
                }
            }
        ]
    },
]